import { SceneDTO } from 'client-generator/generated-clients/plants';
import { Vue, Options } from 'vue-class-component';
import { PropType } from 'vue';

@Options({
  name: 'DialogConfirmDeleteScene',
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
    scene: {
      type: [Object as PropType<SceneDTO>, null],
    },
  },
  watch: {
    isVisible: function (newValue) {
      this.isDialogVisible = newValue;
    },
  },
  emits: ['hide-dialog', 'confirm'],
})
export default class DialogConfirmDeleteScene extends Vue {
  isVisible!: boolean;
  isDialogVisible = false;

  mounted() {
    this.isDialogVisible = this.isVisible;
  }

  handleHideDialog() {
    this.isDialogVisible = false;
  }

  doHideDialog() {
    this.$emit('hide-dialog');
  }

  doConfirm() {
    this.$emit('confirm');
    this.handleHideDialog();
  }
}
